<script setup lang="ts">
import { ref } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import ExamDateModal from '@/components/ExamDateModal.vue'

const {
    InfoMessage,
    Button: PocketButton,
} = UIKit

defineProps<{
    isDarkMode?: boolean
}>()

const emit = defineEmits<{
    'close': []
}>()

const isShowingExamDateModal = ref(false)
</script>

<template>
    <div class="exam-date-banner">
        <ExamDateModal v-if="isShowingExamDateModal" @close="isShowingExamDateModal = false" />
        <InfoMessage
            class="exam-date-banner__message"
            :is-dark-mode="isDarkMode"
            :show-close-button="true"
            @close="emit('close')"
        >
            Add your
            <PocketButton
                type="tertiary"
                :is-dark-mode="isDarkMode"
                @click="isShowingExamDateModal = true"
            >
                exam date
            </PocketButton>
            for personalized tips.
        </InfoMessage>
    </div>
</template>

<style lang="scss" scoped>
.exam-date-banner {
    :deep(.info-message) {
        padding: 9px 12px;

        .info-message__close-btn {
            top: 8.5px;
            right: 8px;
        }
    }

    // Override InfoMessage styles to make mobile web's banner look more like iOS/Android
    @include breakpoint(black-bear) {
        :deep(.info-message) {
            padding: 11px 12px;
            background-color: $brand-black;
            border-color: rgba($pewter, 0.85);

            .info-message__content {
                color: $manilla;

                .uikit-btn--tertiary {
                    color: $banana-bread;
                }
            }

            .info-message__close-btn {
                top: 10px;
                right: 10px;
                color: $pewter;
            }

            @media (hover: hover) {
                .info-message__close-btn:hover {
                    color: $banana-bread;
                }
            }
        }

        :deep(.info-message--dark) {
            background-color: $barely-background;
            border-color: rgba($pewter, 0.85);

            .info-message__content {
                color: $brand-black;

                .uikit-btn--tertiary {
                    color: $brand-blue;
                }
            }

            .info-message__close-btn {
                color: $pewter;
            }

            @media (hover: hover) {
                .info-message__close-btn:hover {
                    color: $brand-blue;
                }
            }
        }
    }
}
</style>
